"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Escape the regex of the given string
 */
function escapeRegex(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
exports.default = escapeRegex;
//# sourceMappingURL=escapeRegex.js.map